import React from "react";
import { Accordion } from "../../../common/commonComponents";
import UpdateProgramActionForm from "./UpdateProgramActionForm";
const ProgramActionUpdate = ({
  programAction,
  applicationId,
  fetchData,
  updateProgramActionPermissions,
  programActionHistory,
}) => {

  return (
    <div>
      <Accordion title="Update Program Action">
        <UpdateProgramActionForm
          applicationId={applicationId}
          programAction={programAction}
          programActionHistory={programActionHistory}
          fetchData={fetchData}
          updateProgramActionPermissions = {updateProgramActionPermissions}
        />
      </Accordion>
    </div>
  );
};

export default ProgramActionUpdate;
